// extracted by mini-css-extract-plugin
export default {"iframe-container":"GrafanaPage_iframe-container__hrDCq","iframe":"GrafanaPage_iframe__t6Hi5"};